import { API } from "@/main.js";

const state = {
  allValidAssetLayers: [
    "fc_pathway",
    "fc_manhole",
    "fc_pole",
    "fc_toby_box",
    "fc_cabinet"
  ],

  allValidNetworkElementLayers: ["fc_building", "fc_closure", "fc_slack"],
  // Valid layers - layers with objects that can have asset reservation that exist inside the selected area
  validLayersInArea: null,

  management: {
    selectedWorkspaceUUID: null
  }
};

const getters = {
  getValidAssetReservationAssetLayers: state => state.allValidAssetLayers,
  getValidAssetReservationNetworkElementLayers: state =>
    state.allValidNetworkElementLayers,
  getValidAssetReservationObjectLayersInArea: state => state.validLayersInArea,
  getAssetReservationManagementSelectedWorkspaceUUID: state =>
    state.management.selectedWorkspaceUUID
};

const mutations = {
  SET_VALID_OBJECT_LAYERS(state, layers) {
    state.validLayersInArea = layers;
  },

  SET_ASSET_RESERVATION_MANAGEMENT_WORKSPACE(state, workspaceUUID) {
    state.management.selectedWorkspaceUUID = workspaceUUID;
  }
};

const actions = {
  fetchAssetReservations(
    { commit },
    { fieldsToAppend = null, workspaceUUID = null, includeDeleted = false }
  ) {
    return new Promise((resolve, reject) => {
      API.assetReservation.getAll(
        fieldsToAppend,
        workspaceUUID,
        includeDeleted,
        resp => {
          let reservations = resp.data.data;
          resolve(reservations);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  fetchAssetReservationTemplates({ commit }, appends = null) {
    return new Promise((resolve, reject) => {
      API.assetReservation.getTemplates(
        appends,
        resp => {
          let templates = resp.data.data;
          resolve(templates);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  fetchAssetReservationTemplateByUUID(
    { commit },
    { templateUUID, appends = null }
  ) {
    return new Promise((resolve, reject) => {
      API.assetReservation.getTemplateByUUID(
        templateUUID,
        appends,
        resp => {
          let template = resp.data.data[0];
          resolve(template);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  createAssetReservationTemplate({ commit }, newData) {
    return new Promise((resolve, reject) => {
      API.assetReservation.createTemplate(
        newData,
        resp => {
          let template = resp.data.data;
          resolve(template);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editAssetReservationTemplate({ commit }, { uuid, data }) {
    return new Promise((resolve, reject) => {
      API.assetReservation.updateTemplate(
        uuid,
        data,
        resp => {
          let template = resp.data.data;
          resolve(template);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  deleteAssetReservationTemplate({ commit }, templateUUID) {
    return new Promise((resolve, reject) => {
      API.assetReservation.deleteTemplate(
        templateUUID,
        resp => {
          let template = resp.data.data;
          resolve(template);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  createAssetReservation({ commit }, newData) {
    return new Promise((resolve, reject) => {
      API.assetReservation.create(
        newData,
        resp => {
          let assetReservation = resp.data.data;
          resolve(assetReservation);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  editAssetReservation({ commit }, { uuid, data }) {
    return new Promise((resolve, reject) => {
      API.assetReservation.update(
        uuid,
        data,
        resp => {
          let assetReservation = resp.data.data;
          resolve(assetReservation);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  createAssetReservationObject(
    { commit },
    { assetReservationUUID, assetReservationObject }
  ) {
    return new Promise((resolve, reject) => {
      API.assetReservation.createAssetReservationObject(
        assetReservationUUID,
        assetReservationObject,
        () => {
          resolve();
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  editAssetReservationObject(
    { commit },
    { assetReservationUUID, objectUUID, assetReservationObject }
  ) {
    return new Promise((resolve, reject) => {
      API.assetReservation.updateAssetReservationObject(
        assetReservationUUID,
        objectUUID,
        assetReservationObject,
        resp => {
          let updatedAssetReservationObject = resp.data.data;
          resolve(updatedAssetReservationObject);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  deleteAssetReservationObject(
    { commit },
    { assetReservationUUID, objectUUID }
  ) {
    return new Promise((resolve, reject) => {
      API.assetReservation.deleteAssetReservationObject(
        assetReservationUUID,
        objectUUID,
        () => {
          resolve();
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  getAssetReservationsByObject({ commit }, { objectEndpoint, objectUUID }) {
    return new Promise((resolve, reject) => {
      API.assetReservation.getAssetReservationsByObject(
        objectEndpoint,
        objectUUID,
        resp => {
          let assetReservationObjects = resp.data.data;
          resolve(assetReservationObjects);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  fetchAssociatedObjectByUuid(
    { commit },
    { assetReservationUuid, objectUUID, fieldsToAppend = null }
  ) {
    return new Promise((resolve, reject) => {
      API.assetReservation.getAssociatedObjectByUuid(
        assetReservationUuid,
        objectUUID,
        fieldsToAppend,
        resp => {
          let assetReservationAssociatedObjects = resp.data.data[0];
          resolve(assetReservationAssociatedObjects);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  setValidAssetReservationObjectLayers({ commit }, layers) {
    commit("SET_VALID_OBJECT_LAYERS", layers);
  },

  setAssetReservationManagementWorkspace({ commit }, workspaceUUID) {
    commit("SET_ASSET_RESERVATION_MANAGEMENT_WORKSPACE", workspaceUUID);
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/assetReservation.js